package ru.villawonka.app.data.repository

import ru.villawonka.app.data.entity.request.TelegramAuthRequest
import ru.villawonka.app.data.source.AuthApi
import ru.villawonka.app.platform.platform.Platform
import ru.villawonka.app.platform.telegram.Telegram

class AuthRepository(
    private val authApi: AuthApi,
    private val platform: Platform,
    private val telegram: Telegram?,
) {
    var token: String? = null
        private set

    var isNewUser: Boolean = false
        private set

    suspend fun refreshToken(): String? = telegram?.let {
        val authResponse = authApi.authByTelegram(
            request = TelegramAuthRequest(
                initData = telegram.getInitData(),
                deviceName = platform.deviceInfo.deviceName,
                osName = platform.deviceInfo.osName,
                osVersion = platform.deviceInfo.osVersion
            )
        )

        isNewUser = authResponse.isNew
        token = authResponse.accessToken

        authResponse.accessToken
    }
}